import isEqual from "lodash/isEqual";
import type {
  IApiResponse,
  UserFriendsShoppingSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { TagsType } from "../constants";

export const userReferralsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getFoundationUserReferralPurchase: build.query<
      IApiResponse<UserFriendsShoppingSerializer[]>["payload"],
      {
        limit: number;
        offset?: number;
      }
    >({
      query: ({ limit, offset }) => {
        return {
          url: "/foundation/api/users/me/friends-shopping",
          params: { limit, offset },
        };
      },
      providesTags: [TagsType.USER_REFERRALS],
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      transformResponse: (
        response: IApiResponse<UserFriendsShoppingSerializer[]>
      ) => {
        return response.payload;
      },
      merge: (currentCacheData, responseData, { arg }) => {
        if (arg.offset) {
          currentCacheData.data.push(...responseData.data);
        } else {
          currentCacheData.data = responseData.data;
        }

        currentCacheData.pagination = responseData.pagination;
      },
      forceRefetch({ currentArg, previousArg }) {
        return !isEqual(currentArg, previousArg);
      },
    }),
  }),
});
